<template>
  <DropdownInput
    :disabled="disabled"
    :items="items"
    :modelValue="value"
    @update:modelValue="handleChange"
    name="frequency"
  />
</template>

<script setup>
import { RRule } from "rrule";
import { defineProps, defineEmits, computed } from "vue";
import { useI18n } from "vue-i18n";

import DropdownInput from "@/Tailwind/Components/Input/DropdownInput";

const { t } = useI18n();

const emit = defineEmits(["change"]);

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  value: Number,
});

function handleChange(v) {
  emit("change", Number(v));
}

const items = computed(() => {
  return [
    {
      label: t("admin.tasks.recurring.interval.daily"),
      value: RRule.DAILY,
    },
    {
      label: t("admin.tasks.recurring.interval.weekly"),
      value: RRule.WEEKLY,
    },
    {
      label: t("admin.tasks.recurring.interval.monthly"),
      value: RRule.MONTHLY,
    },
    {
      label: t("admin.tasks.recurring.interval.yearly"),
      value: RRule.YEARLY,
    },
  ];
});
</script>
